



































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { SubmitArgs as StudentSelectedArgs } from '@/components/student/studentSelectDialog.vue';
import ReportEditor from '@/components/report/reportEditor.vue';
import { Report } from '@/modules/report';
import { Person } from '@/models/person';
import { Subject } from '@/models/subject';
import { ReadTypes } from '@/enums/readTypes';
import { PublicTypes, getPublicTypeName } from '@/enums/publicTypes';
import { AttachmentFile } from '@/models/attachmentFile';
import { ReportCreateArgs } from '@/modules/reservation';

interface ValidReport extends Report {
  validateOK: boolean;
}

@Component({
  components: {
    'report-editor': ReportEditor
  }
})
export default class ReportEdit extends Vue {
  @Prop() private reportId: string;

  private isEdit = false;
  private initReport: ValidReport = {
    id: '',
    tutorId: '',
    tutorUserId: '',
    tutorName: '',
    studentId: '',
    studentUserId: '',
    studentName: '',
    lessonStartDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
    lessonEndDate: null,
    sendDate: null,
    attachment: 0,
    subjectList: new Array<Subject>(),
    readType: ReadTypes.Unread,
    reportSummary: '',
    reportNote: '',
    sharingNote: '',
    updateDate: new Date(),
    publicType: PublicTypes.Private,
    publicTypeName: '',
    attachments: new Array<AttachmentFile>(),
    validateOK: false,
  };
  private editInfo: ValidReport = JSON.parse(JSON.stringify(this.initReport));
  private reports = new Array<ValidReport>();
  private reportSource: ValidReport | null = null;
  private targetStudentId = '';
  private studentSelectVisible = false;

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  get selectedStudents(): Person[] {
    const students = new Array<Person>();
    this.reports.forEach((report) => {
      students.push({
        id: report.studentId,
        name: report.studentName
      });
    });
    return students;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  @Watch('schoolId')
  private changeSchoolId() {
    this.removeEventListener();
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private destroyed() {
    this.removeEventListener();
  }

  private async loadData() {
    const page = String(this.$route.name);
    const isEdit = (page.toUpperCase() === 'reportEdit'.toUpperCase());

    this.isEdit = isEdit;

    let report: ValidReport | null = null;
    if (!!this.reportId) {
      report = await this.$store.dispatch('report/getReportDetails', this.reportId).catch((error) => {
        return null;
      });
      if (!report) {
        this.$router.push({ name: 'ReportList' });
        return;
      }
    }
    if (isEdit) {
      if (!report) {
        this.$router.push({ name: 'ReportList' });
        return;
      }
      this.reports = [report];
      this.onSelectReport(report.studentId);
    } else {
      const reportCreateArgsList: ReportCreateArgs[] = this.$store.state.reservation.reportCreateArgsList;
      this.$store.commit('reservation/setReportCreateArgsList', []);
      if (reportCreateArgsList && reportCreateArgsList.length > 0) {
        if (reportCreateArgsList.length === 1 && !reportCreateArgsList[0].studentId) {
          this.reportSource = this.initReport;
          this.reportSource.lessonStartDate = reportCreateArgsList[0].startDate!;
          this.reportSource.lessonEndDate = reportCreateArgsList[0].endDate!;
          this.reportSource.subjectList = reportCreateArgsList[0].subjects;
          this.studentSelectVisible = true;
        } else {
          this.createReportByArgsList(reportCreateArgsList);
          this.studentSelectVisible = false;
        }
      } else {
        this.reportSource = report;
        this.studentSelectVisible = true;
      }
    }

    this.$nextTick(() => {
      this.addEventListener();
    });
  }

  private addEventListener() {
    window.addEventListener('beforeunload', this.leaving);
  }

  private removeEventListener() {
    window.removeEventListener('beforeunload', this.leaving);
  }

  private leaving(e: any) {
    e.returnValue = '';
  }

  private onValidateEdit() {
    this.checkAllValidation();
  }

  private checkAllValidation() {
    this.reports.forEach((report) => {
      report.validateOK = (
        !!report.reportSummary && report.reportSummary !== '' &&
        !!report.reportNote && report.reportNote !== ''
      );
    });
    return !this.reports.find((report) => !report.validateOK);
  }

  private createReportByArgsList(reportCreateArgsList: ReportCreateArgs[]) {
    this.reports = reportCreateArgsList.map((reportCreateArgs) => ({
      id: '',
      tutorId: '',
      tutorUserId: '',
      tutorName: '',
      studentId: reportCreateArgs.studentId,
      studentUserId: '',
      studentName: reportCreateArgs.studentName,
      lessonStartDate: reportCreateArgs.startDate!,
      lessonEndDate: reportCreateArgs.endDate,
      sendDate: null,
      attachment: 0,
      subjectList: reportCreateArgs.subjects,
      readType: ReadTypes.Unread,
      reportSummary: '',
      reportNote: '',
      sharingNote: '',
      updateDate: new Date(),
      publicType: PublicTypes.Private,
      publicTypeName: '',
      attachments: new Array<AttachmentFile>(),
      validateOK: false,
    }));

    this.checkAllValidation();

    this.onSelectReport(this.reports[0].studentId);
  }

  private async onSubmitSelectedStudents(args: StudentSelectedArgs) {
    const selectedStudents = args.selectedStudents;
    if (!selectedStudents || selectedStudents.length === 0) {
      args.cancelClose = true;
      return;
    }

    const selectedReports = this.reports.filter((item) => {
      return !!selectedStudents.find((selectedItem) => {
        return selectedItem.id ===  item.studentId;
      });
    });

    let reportSource = this.reportSource;
    if (!reportSource) {
      reportSource = {
        id: '',
        tutorId: '',
        tutorUserId: '',
        tutorName: '',
        studentId: '',
        studentUserId: '',
        studentName: '',
        lessonStartDate: new Date(),
        lessonEndDate: null,
        sendDate: null,
        attachment: 0,
        subjectList: new Array<Subject>(),
        readType: ReadTypes.Unread,
        reportSummary: '',
        reportNote: '',
        sharingNote: '',
        updateDate: new Date(),
        publicType: PublicTypes.Private,
        publicTypeName: '',
        attachments: new Array<AttachmentFile>(),
        validateOK: false,
      };
      reportSource.lessonStartDate.setHours(0);
      reportSource.lessonStartDate.setMinutes(0);
    }
    const reportCopy = reportSource as ValidReport;

    selectedStudents.forEach((item) => {
      const contains = !!selectedReports.find((report) => {
        return report.studentId === item.id;
      });
      if (!contains) {
        selectedReports.push({
          id: '',
          studentId: item.id,
          studentUserId: '',
          studentName: item.name,
          tutorId: '',
          tutorUserId: '',
          tutorName: '',
          lessonStartDate: reportCopy.lessonStartDate,
          lessonEndDate: reportCopy.lessonEndDate,
          sendDate: reportCopy.sendDate,
          attachment: reportCopy.attachment,
          subjectList: JSON.parse(JSON.stringify(reportCopy.subjectList)),
          readType: ReadTypes.Unread,
          reportSummary: reportCopy.reportSummary,
          reportNote: reportCopy.reportNote,
          sharingNote: reportCopy.sharingNote,
          updateDate: reportCopy.updateDate,
          publicType: PublicTypes.Private,
          publicTypeName: getPublicTypeName(PublicTypes.Private),
          attachments: JSON.parse(JSON.stringify(reportCopy.attachments)),
          validateOK: reportCopy.validateOK,
        });
      }
    });
    this.reports = selectedReports;

    this.checkAllValidation();

    this.onSelectReport(this.reports[0].studentId);
  }

  private onCancelSelectedStudents() {
    if (this.reports.length === 0) {
      this.$router.push({ name: 'ReportList' });
    }
  }

  private async onBulkEdit() {
    const form: ValidReport = JSON.parse(JSON.stringify(this.initReport));
    for (const key of Object.keys(form)) {
      const checkValue = (this.reports[0] as any)[key];
      let check = false;
      if (key === 'attachments') {
        continue;
      }
      if (key === 'subjectList') {
        const checkSubjectId = checkValue.map((subject: any) => subject.id);
        const checkSubjectIdJson = JSON.stringify(checkSubjectId.sort());
        check = this.reports.findIndex((report: any) => {
          const reportSubjectId = report[key].map((subject: any) => subject.id);
          return JSON.stringify(reportSubjectId.sort()) !== checkSubjectIdJson;
        }) < 0;
      } else {
        const checkValueJson = JSON.stringify(checkValue);
        check = this.reports.findIndex((report: any) => {
          return JSON.stringify(report[key]) !== checkValueJson;
        }) < 0;
      }
      if (check) {
        (form as any)[key] = checkValue;
      }
    }
    form.studentId = 'BulkEdit';

    try {
      const result = await (this.$refs.reportEdit as DialogWrapper).open({...form}) as Report;

      this.$el.querySelector('.bulk-report-edit-dialog')!.scrollTop = 0;

      const reflection = (this.$refs.bulkEdit as ReportEditor).reflection;
      this.reports.forEach((report) => {
        if (reflection.lessonDate) {
          report.lessonStartDate = result.lessonStartDate;
          report.lessonEndDate = result.lessonEndDate;
        }
        if (reflection.subjects) {
          report.subjectList = JSON.parse(JSON.stringify(result.subjectList));
        }
        if (reflection.summary) {
          report.reportSummary = result.reportSummary;
        }
        if (reflection.details) {
          report.reportNote = result.reportNote;
        }
        if (reflection.attachments) {
          report.attachments = result.attachments.map((file) => {
            return {
              url: file.url,
              name: file.name,
              localUrl: file.localUrl,
              isDelete: file.isDelete,
              raw: file.raw,
            };
          });
        }
        if (reflection.insideInfo) {
          report.sharingNote = result.sharingNote;
        }
      });
    } catch (error) {
      this.$el.querySelector('.bulk-report-edit-dialog')!.scrollTop = 0;
      return;
    }

    this.checkAllValidation();
  }

  private onSelectReport(studentId: string) {
    this.targetStudentId = studentId;
    const report = this.reports.find((item) => {
      return item.studentId === studentId;
    });
    if (!!report) {
      this.editInfo = report;
    }
    this.checkAllValidation();
  }

  private onRegist() {
    (this.$refs.editor as ReportEditor).validate();
    if (!this.checkAllValidation()) {
      this.$notify.error({
        title: 'エラー',
        message: '入力項目が不足しています。',
        position: 'bottom-right'
      });
      return;
    }

    if (this.isEdit) {
      this.editReport();
    } else {
      this.createReport();
    }
  }

  private async createReport() {
    try {
      await this.$confirm('指導報告書を登録します。よろしいですか？', '指導報告書登録', {
        confirmButtonText: '登録',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    await Promise.all(this.reports.reduce((list, report) => {
      const uploadFiles = report.attachments.map(async (item) => {
        if (!item.isDelete && !!item.url && !item.raw) {
          try {
            item.raw  = await this.$store.dispatch('file/getFile', {
              url: item.url,
              name: item.name,
            });
          } catch (error) {
            return;
          }
        }
      });
      list.push(...uploadFiles);
      return list;
    }, new Array<Promise<void>>()));

    try {
      await this.$store.dispatch('report/createReports', {
        reportList: this.reports,
        schoolId: this.schoolId,
      });

      await this.$store.dispatch(
        'report/searchReports',
        this.$store.state.report.searchCondition
      );

      this.$router.push({ name: 'ReportList' });

      this.$notify({
        title: '登録完了',
        message: '指導報告書を登録しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify({
        title: 'エラー',
        message: '指導報告書の登録に失敗しました。',
        position: 'bottom-right'
      });
    }
  }

  private async editReport() {
    try {
      await this.$confirm('指導報告書を変更します。よろしいですか？', '指導報告書変更', {
        confirmButtonText: '変更',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('report/editReport', {
        report: this.reports[0],
        schoolId: this.schoolId,
      });

      this.$router.push({ name: 'ReportList' });

      this.$notify({
        title: '変更完了',
        message: '指導報告書を変更しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify({
        title: 'エラー',
        message: '指導報告書の変更に失敗しました。',
        position: 'bottom-right'
      });
    }
  }

  private onCancel() {
    this.$router.push({ name: 'ReportList' });
  }
}
